export { default } from './LoanDenial';
